import { render, staticRenderFns } from "./WordInputComponent.vue?vue&type=template&id=1d9bef24&scoped=true&"
import script from "./WordInputComponent.vue?vue&type=script&lang=ts&"
export * from "./WordInputComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WordInputComponent.vue?vue&type=style&index=0&id=1d9bef24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9bef24",
  null
  
)

export default component.exports